export {useGlobalContext as useGlobal} from '../context/GlobalContext'